﻿export const isLoggedIn = () =>
{
	return document.querySelector("meta[name=loggedin][content=true]") != null;
}
